import { ROUNDING_BEHAVIOR } from "@miplatform/constants";

export const DROP_NAME_COL_WIDTH = 217;

export const PRICE_LVL_COL_WIDTH = 150;

export const DEFAULT_VALUES = {
  name: "",
  percentAdjustment: 0,
  roundingBehavior: ROUNDING_BEHAVIOR.NONE,
  displayOrder: 1,
  isActive: true,
  parentId: undefined,
  descendentPriceLevels: undefined,
  dropPrices: [],
};
